import React from 'react'

const FaqIcon = (
  <>
    <path
      d="M42.25 3.5H6.25C3.49 3.503 1.253 5.74 1.25 8.5V29.5C1.253 32.26 3.49 34.497 6.25 34.5H11.25V44.5C11.25 45.052 11.698 45.5 12.25 45.5C12.474 45.5 12.692 45.425 12.868 45.286L26.596 34.5H42.25C45.01 34.497 47.247 32.26 47.25 29.5V8.5C47.247 5.74 45.01 3.503 42.25 3.5Z"
      fill="url(#paint0_linear_2195_31525)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2195_31525"
        x1="24.25"
        y1="3.5"
        x2="24.25"
        y2="45.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEF2FD" />
        <stop offset="1" stopColor="#9ED9FA" />
      </linearGradient>
    </defs>
  </>
)

export default FaqIcon
